import { render } from "./CmsWidgets.vue?vue&type=template&id=089b2916&lang=html"
import script from "./CmsWidgets.vue?vue&type=script&lang=js"
export * from "./CmsWidgets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__